import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/linkoping")(
  heritageCityRoute({
    citySlug: "linkoping",
    angle:
      "I Linköping möter vi universitetsmiljön, teknikbolagen och de ägarledda industriföretagen i Östergötland — där kunskap ofta sitter hos enskilda ingenjörer och grundare som byggt verksamheten från grunden.",
    localUseCases: [
      "Filmad livsberättelse hemma i Linköping med omnejd",
      "Grundarporträtt i teknik- och ingenjörsbolag",
      "Kunskapsöverföring inför pension i industriföretag",
      "Dokumentation av forskningsgärning och yrkesliv",
      "Generationsskifte i östgötska familjeföretag",
      "Minnesfilm inför jubileum eller minnesstund"
    ],
  }),
);
